module.exports = __webpack_public_path__ + "static/media/Leave2.53ec0e73.svg";